import script from "./Config.vue?vue&type=script&setup=true&lang=js"
export * from "./Config.vue?vue&type=script&setup=true&lang=js"

import "./Config.vue?vue&type=style&index=0&id=7c98947d&lang=postcss&scoped=true"

import exportComponent from "/builds/atlatl-software/atlatl-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c98947d"]])

export default __exports__